import React, { FunctionComponent, ReactNode } from 'react'
import styles from './style.module.scss'
import clsx from 'clsx'

export interface RadioFooterProps {
  children: ReactNode
  sticky?: boolean
  testNameSpace?: string
}

export const RadioFooter: FunctionComponent<RadioFooterProps> = ({ children, sticky = false, testNameSpace = '' }) => {
  const footerClassName = clsx(styles.footer, sticky && styles.sticky)

  return (
    <div className={footerClassName} {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-radio-footer` })}>
      {children}
    </div>
  )
}
